import "./App.css";
import Header from "./components/Header.jsx";
import Footer from "./components/Footer.jsx";
import ScrollProgress from "./components/ScrollProgress.jsx";
import { Routes, Route } from "react-router-dom";
import { FloatingWhatsApp } from "@digicroz/react-floating-whatsapp";
import Homepage from "./pages/Homepage.jsx";
import ServicesPage from "./pages/ServicesPage.jsx";
import AboutPage from "./pages/AboutPage.jsx";
import ContactPage from "./pages/ContactPage.jsx";
import logo from "./resources/logo.png";

function App() {
  return (
    <div className="App">
      <ScrollProgress />
      <Header />
      <Routes>
        <Route path="/" exact element={<Homepage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/aboutus" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
      <Footer />
      <FloatingWhatsApp
        phoneNumber="13475820864"
        accountName="Bini Autorepair INC"
        avatar={logo}
        statusMessage="Typically replies within an hour"
        chatMessage="Hello! 👋 How can we help with your vehicle today?"
        allowClickAway
        allowEsc
        notification
        notificationSound={false}
      />
    </div>
  );
}

export default App;
